var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBloodOxygen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 29.5002L29.5 13.5002M17.5 15.5002C17.5 16.0307 17.2893 16.5394 16.9142 16.9145C16.5391 17.2895 16.0304 17.5002 15.5 17.5002C14.9696 17.5002 14.4609 17.2895 14.0858 16.9145C13.7107 16.5394 13.5 16.0307 13.5 15.5002C13.5 14.9698 13.7107 14.4611 14.0858 14.086C14.4609 13.711 14.9696 13.5002 15.5 13.5002C16.0304 13.5002 16.5391 13.711 16.9142 14.086C17.2893 14.4611 17.5 14.9698 17.5 15.5002ZM29.5 27.1562C29.5 27.6867 29.2893 28.1954 28.9142 28.5705C28.5391 28.9455 28.0304 29.1562 27.5 29.1562C26.9696 29.1562 26.4609 28.9455 26.0858 28.5705C25.7107 28.1954 25.5 27.6867 25.5 27.1562C25.5 26.6258 25.7107 26.1171 26.0858 25.742C26.4609 25.367 26.9696 25.1562 27.5 25.1562C28.0304 25.1562 28.5391 25.367 28.9142 25.742C29.2893 26.1171 29.5 26.6258 29.5 27.1562Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 41.5C32.5457 41.5 41.5 32.5457 41.5 21.5C41.5 10.4543 32.5457 1.5 21.5 1.5C10.4543 1.5 1.5 10.4543 1.5 21.5C1.5 32.5457 10.4543 41.5 21.5 41.5Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloodOxygen);
export default __webpack_public_path__ + "static/media/bloodOxygen.2300e4386624aae96d8c198ba04e4b09.svg";
export { ForwardRef as ReactComponent };